import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import Avatar from "@mui/material/Avatar";
import Box from "@mui/material/Box";
import { useCompany } from "../../components/context/CompanyContext";
import CustomGrid from "../../components/grid/CustomGrid";
import Loading from "../../components/loading/loading";
import { titleSetRef } from "../../redux/titleRedux";
import { userRequest, generateFileUrl } from "../../requestMethods";
import "../../App.css";

const BASE_COLUMNS = [
  {
    field: "avatar",
    type: "text",
    headerName: "Foto",
    align: "center",
    headerAlign: "center",
    width: 50,
    renderCell: (params) => (
      <Avatar sx={{ width: "30px", height: "30px" }} src={generateFileUrl(params.value)} />
    ),
  },
  { field: "product", type: "text", headerName: "Referência", width: 150, align: "center", headerAlign: "center" },
  {
    field: "color",
    type: "text",
    headerName: "Cor",
    width: 60,
    align: "center",
    headerAlign: "center",
    renderCell: (params) => (
      <Box sx={{ height: "30px", width: "30px", backgroundColor: params.value, borderRadius: "5px" }} />
    ),
  },
  { field: "colorRef", type: "text", headerName: "", width: 50, align: "center", headerAlign: "center" },
];

// Tela dedicada "Grade Incompleta" — mesmo report do productReport.jsx (tabela
// gridStock via /grid/stock, colunas avatar/referência/cor + tamanhos dinâmicos).
export default function RelatorioGradeIncompleta() {
  const dispatch = useDispatch();
  const nav = useNavigate();
  const { companyId, slug } = useCompany();

  const [rows, setRows] = useState([]);
  const [columns, setColumns] = useState(BASE_COLUMNS);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    dispatch(titleSetRef({ title: "Grade Incompleta" }));
    window.scrollTo(0, 0);
  }, [dispatch]);

  useEffect(() => {
    if (companyId > 0) carregar();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [companyId]);

  const carregar = async () => {
    setIsLoading(true);
    try {
      try {
        const resSizes = await userRequest.get(`${companyId}/products/sizes`);
        const sorted = [...(resSizes.data || [])].sort(
          (a, b) => (a.order ?? 9999) - (b.order ?? 9999) || a.id - b.id,
        );
        const sizeCols = sorted.map((item) => ({
          field: item.label,
          headerName: item.label,
          width: 50,
          align: "center",
          headerAlign: "center",
        }));
        setColumns([...BASE_COLUMNS, ...sizeCols]);
      } catch {}

      const res = await userRequest.get(`${companyId}/grid/stock`);
      setRows(Array.isArray(res.data) ? res.data : []);
    } catch {
      setRows([]);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div style={{ padding: "16px 16px 48px 4px", fontFamily: "Manrope", background: "#F9FAFB", minHeight: "100vh" }}>
      <div
        onClick={() => nav(`/${slug}/indicadoresprodutos`)}
        style={{
          display: "inline-flex", alignItems: "center", gap: 6, marginBottom: 12, cursor: "pointer",
          color: "#6B7280", fontSize: 13, fontWeight: 600, fontFamily: "Manrope",
          padding: "6px 12px", borderRadius: 8, border: "1px solid #E5E7EB",
          background: "#fff", boxShadow: "0 1px 4px rgba(0,0,0,0.05)",
        }}
      >
        ← Voltar para Indicadores
      </div>

      <div style={{ marginBottom: 20 }}>
        <span style={{ fontSize: 18, fontWeight: 700, color: "#111827" }}>Grade Incompleta</span>
        <span style={{ fontSize: 12, color: "#9CA3AF", marginLeft: 8 }}>Exibindo todos os dados</span>
      </div>

      {isLoading ? (
        <Loading />
      ) : (
        <div style={{ background: "#fff", borderRadius: 14, border: "1px solid #E5E7EB", boxShadow: "0 2px 8px rgba(0,0,0,0.06)", padding: "16px" }}>
          <div style={{ height: "calc(100vh - 200px)", width: "100%" }}>
            <CustomGrid
              gridId="relatorioGradeIncompleta"
              rows={rows}
              columns={columns}
              pageSize={45}
              checkboxSelection={false}
            />
          </div>
        </div>
      )}
    </div>
  );
}
